import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from '../../services/shared-http.service';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
import { CaseService } from '../../services/case.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-objecion-details',
  templateUrl: './objecion-details.component.html',
  styleUrls: ['./objecion-details.component.scss']
})
export class ObjecionDetailsComponent implements OnInit {

  @Input() loadDataFP: Observable<any>;
  caseObj:any;
  decsionObject:any;
  constructor(public sharedService: SharedHttpService, public caseService : CaseService) { }
  ngOnInit(): void {
    this.decsionObject=undefined;
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
        this.loadData();
      }, 100);
    });
  }
  loadData() {
    this.caseObj=this.caseService.getCaseData();
    this.sharedService.get(`api/Decsion/GetCaseDecsion?eCaseId=${this.caseObj.eCaseId}`).subscribe(res => {
      this.decsionObject=res;
    });
  }

}
